
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Edit, MoreHorizontal, Trash2, User, MapPin } from "lucide-react";
// Note: This component uses mock data and needs to be updated for Firebase integration
// Placeholder interfaces and functions
interface Location { id: string; defaultAssigneeId?: string; growerId: string; farmId: string; fieldId: string; }
const mockTeam: any[] = [];
const getGrowerById = (id: string) => null;
const getFarmById = (id: string) => null;
const getFieldById = (id: string) => null;
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface LocationCardProps {
  location: Location;
  onEdit: (locationId: string) => void;
  onDelete: (locationId: string) => void;
}

const LocationCard: React.FC<LocationCardProps> = ({ location, onEdit, onDelete }) => {
  const grower = getGrowerById(location.growerId);
  const farm = getFarmById(location.farmId);
  const field = getFieldById(location.fieldId);
  const assignee = mockTeam.find(member => member.id === location.defaultAssigneeId);

  return (
    <Card className="w-full relative">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
          <CardTitle className="text-lg text-agri-green-dark">{field?.name || "Unknown Field"}</CardTitle>
          <div className="absolute top-2 right-2">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button 
                  className="h-8 w-8 flex items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none"
                >
                  <MoreHorizontal className="h-4 w-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-32">
                <DropdownMenuItem onClick={() => onEdit(location.id)} className="cursor-pointer">
                  <Edit className="h-4 w-4 mr-2" />
                  Edit
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => onDelete(location.id)} className="text-red-600 focus:text-red-600 cursor-pointer">
                  <Trash2 className="h-4 w-4 mr-2" />
                  Delete
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
        <CardDescription className="flex items-center">
          <MapPin className="h-4 w-4 mr-1 text-gray-500" />
          {grower?.name || "Unknown Grower"} • {farm?.name || "Unknown Farm"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-sm">
          {field && <div>Field Size: {field.acres} acres</div>}
        </div>
      </CardContent>
      <CardFooter className="pt-0">
        <div className="flex items-center text-sm text-gray-500">
          <User className="h-4 w-4 mr-1" />
          Default Assignee: {assignee?.firstName} {assignee?.lastName || "Unassigned"}
        </div>
      </CardFooter>
    </Card>
  );
};

export default LocationCard;
